document.addEventListener("DOMContentLoaded", function () {
  let totalPages = 0;

  function createPaginationLinks(totalPages) {
    const head = document.querySelector("head");

    function getCurrentPage() {
      const urlParams = new URLSearchParams(window.location.search);
      return parseInt(urlParams.get("page")) || 1;
    }

    function updatePaginationLinks() {
      const currentPage = getCurrentPage();

      const existingLinks = document.querySelectorAll('link[rel="prev"], link[rel="next"]');
      existingLinks.forEach((link) => link.remove());

      if (currentPage > 1) {
        const prevLink = document.createElement("link");
        prevLink.rel = "prev";
        prevLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${currentPage - 1
          }`;
        head.appendChild(prevLink);
      }

      if (currentPage < totalPages) {
        const nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}?page=${currentPage + 1
          }`;
        head.appendChild(nextLink);
      }
    }

    // first time initialization
    updatePaginationLinks();

    // update on page change
    window.addEventListener("popstate", updatePaginationLinks);

    const originalPushState = history.pushState;
    history.pushState = function (state, title, url) {
      originalPushState.call(history, state, title, url);
      updatePaginationLinks();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (state, title, url) {
      originalReplaceState.call(history, state, title, url);
      updatePaginationLinks();
    };
  }

  function tryInitPagination() {
    const showingItemsElement = document.querySelector(".collection-items-number");
    if (!showingItemsElement) return false;
    const text = showingItemsElement.textContent.trim();
    const match = text.match(/(\d+)\s*$/);
    if (!match) return false;
    const totalResults = parseInt(match[1]);
    if (!totalResults) return false;
    const products = document.querySelectorAll("#searchspring-content .product-card");
    if (!products.length) return false;
    totalPages = Math.ceil(totalResults / products.length);
    createPaginationLinks(totalPages);
    return true;
  }

  if (!tryInitPagination()) {
    const observerTarget = document.querySelector("#searchspring-content") || document.body;
    const observer = new MutationObserver(function () {
      if (tryInitPagination()) observer.disconnect();
    });
    observer.observe(observerTarget, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  // replace h1 tags with h2 tags in the collection description

  const descriptionEl = document.querySelector('.collection-section__description');
  if (descriptionEl) {
    const h1Tags = descriptionEl.querySelectorAll('h1');
    h1Tags.forEach(function (h1) {
      const h2 = document.createElement('h2');
      h2.innerHTML = h1.innerHTML;
      h2.className = h1.className;
      h2.id = h1.id;
      Array.from(h1.attributes).forEach(attr => {
        if (attr.name !== 'class' && attr.name !== 'id') {
          h2.setAttribute(attr.name, attr.value);
        }
      });
      h1.parentNode.replaceChild(h2, h1);
    });
  }
});
